import BaseMystery from '../BaseMystery'

const SecondJoyfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/e/ezquerra/cycle4.jpg",
		"https://www.wga.hu/art/b/bouts/dirk_e/altar/1tripti2.jpg",
		"https://www.wga.hu/art/a/angelico/04/3predel2.jpg",
		"https://www.wga.hu/art/a/albertin/visitat4.jpg",
		"https://www.wga.hu/art/a/albertin/visitat.jpg",
		"https://www.wga.hu/art/b/bregno/lorenzo/treviso.jpg",
		"https://www.wga.hu/art/c/carpacci/2/064virgi.jpg",
		"https://www.wga.hu/art/c/castill/visitati.jpg",
		"https://www.wga.hu/art/d/daret/stvaast2.jpg",
		"https://www.wga.hu/art/g/gandolfi/ubaldo/visitati.jpg",
		"https://www.wga.hu/art/g/ghirland/domenico/6tornab/62tornab/2visita.jpg",
		"https://www.wga.hu/art/g/ghirland/domenico/7panel/09visita.jpg",
		"https://www.wga.hu/art/g/giambono/mascoli2.jpg",
		"https://www.wga.hu/art/g/giotto/padova/2virgin/mary10.jpg",
		"https://www.wga.hu/art/g/giotto/assisi/lower/ceiling/01christ.jpg",
		"https://www.wga.hu/art/g/gutierr/2virgin.jpg",
		"https://www.wga.hu/art/h/herp/visitati.jpg",
		"https://www.wga.hu/art/h/herrera/franci_e/visitati.jpg",
		"https://www.wga.hu/art/l/lorenzo/monaco/1/15monaco.jpg",
		"https://www.wga.hu/art/m/master/ms/1visita.jpg",
		"https://www.wga.hu/art/m/master/ab/panel2.jpg",
		"https://www.wga.hu/art/m/master/life/bvisitat.jpg",
		"https://www.wga.hu/art/m/maulbert/08vac1.jpg",
		"https://www.wga.hu/art/p/pontormo/1/01visit.jpg",
		"https://www.wga.hu/art/p/pontormo/3/05visitb.jpg",
		"https://www.wga.hu/art/p/puget/painting/03visita.jpg",
		"https://www.wga.hu/art/s/salviati/2/2visita1.jpg",
		"https://www.wga.hu/art/s/schiavo/predell1.jpg",
		"https://www.wga.hu/art/s/sebastia/visitati.jpg",
		"https://www.wga.hu/art/t/tintoret/1_1540s/6visitat.jpg",
		"https://www.wga.hu/art/t/tintoret/5_1580s/1visitat.jpg",
		"https://www.wga.hu/art/m/master/zunk_sp/zunk_sp2/08visita.jpg",
		"https://www.wga.hu/art/u/unterber/michelan/visitati.jpg",
		"https://www.wga.hu/art/w/weyden/rogier/17other/3visitat.jpg",
	];

	const scriptureQuote = "\"Most blessed are you among women, and blessed is the fruit of your womb. And how does this happen to me, that the mother of my Lord should come to me?\"";
	const scriptureCitation = "Luke 1:42-43 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%201%3A39-56&version=NABRE";

	return (
		<BaseMystery titleText="The Visitation"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default SecondJoyfulMystery;